/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentServiceability
 * @hideconstructor
 * @classdesc API class that is used to control transactional operations across API calls
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./ContentServiceabilityAPI',
	'./impl/ContentServiceabilityImpl'
], (_, APIFactory, ContentServiceabilityApi, ContentServiceabilityImpl) => {
	class ContentServiceability {
		constructor(options) {
			this._api = APIFactory.createAPI(new ContentServiceabilityImpl(options), [ContentServiceabilityApi]);
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this._api = null;
		}
	}
	return ContentServiceability;
});